import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html'
})
export class MainContentComponent implements OnInit {
  @Output() scrollStatus: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private commonDataService: CommonDataService, private route: Router) { }

  ngOnInit(): void {
    this.hideLoader();
    this.commonDataService.showLoader.subscribe(data => {
      if (data) {
        this.showLoader();
      }
      else {
        this.hideLoader();
      }
    })
  }

  showLoader() {
    document.getElementById("loader-overlay").style.display = "block";
  }
  hideLoader() {
    document.getElementById("loader-overlay").style.display = "none";
  }
  windowScrolled: boolean = false;
  @HostListener('scroll', ['$event'])
  onScroll(e) {
    if (this.route.url.split("/").length > 2) {
      if (document.getElementsByTagName('app-main-content')[0]?.scrollTop > 100) {
        this.scrollStatus.emit(true);
      }
      else {
        this.scrollStatus.emit(false);
      }
    }
  }
}
